module.exports = __webpack_public_path__ + "static/media/login-back-adm-web.467e0c7a.jpg";